import { createRouter, createWebHistory } from "vue-router";
import { routes } from "vue-router/auto-routes";

import { IMPERSONATION_BASE } from "@/lib/environment";

const router = createRouter({
  history: createWebHistory(IMPERSONATION_BASE),
  routes: [
    ...routes,
    { path: "/settings/data", redirect: "/settings/files" },
    {
      path: "/settings/data/attachments/:id",
      redirect: (to) =>
        `/settings/files/attachments/${(to.params as { id: string }).id}`,
    },
    {
      path: "/settings/data/exports/:id",
      redirect: (to) =>
        `/settings/files/exports/${(to.params as { id: string }).id}`,
    },
  ],
});

export default router;
